import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllUserAction,
  GetConnectionListAction,
  GetUserDetailAction,
  StatusManageUserAction,
} from "store/middlewares/user";

// isDeleteMeFulFilled
export const userSlice = createSlice({
  name: "user",
  initialState: {
    userLoading: true,
    user: null,
    userDetailLoading: true,
    userDetail: null,
    connection: null,
    connectionLoading: false,
  },
  extraReducers(builder) {
    builder

      //get user
      .addCase(GetAllUserAction.pending, (state) => {
        // state.usersLoading = state.users?.users?.length > 0 ? false : true;
        state.user = state.user?.result?.length > 0 ? state.user : state.user;
      })
      .addCase(GetAllUserAction.fulfilled, (state, action) => {
        state.userLoading = false;
        state.user = action.payload.response;
      })
      .addCase(GetAllUserAction.rejected, (state) => {
        state.userLoading = false;
        state.user = null;
      })

      //Delete user
      .addCase(StatusManageUserAction.fulfilled, (state, action) => {
        state.userLoading = false;
        state.user = action.payload.response;
      })

      //get connection
      .addCase(GetConnectionListAction.pending, (state) => {
       state.connection =
          state.connection?.result?.length > 0 ? state.connection : null;
      })
      .addCase(GetConnectionListAction.fulfilled, (state, action) => {
        state.connectionLoading = false;
        state.connection = action.payload.response;
      })
      .addCase(GetConnectionListAction.rejected, (state) => {
        state.connectionLoading = false;
        state.connection = null;
      })

      //get user detail
      .addCase(GetUserDetailAction.pending, (state) => {
        state.userDetailLoading = true;
        state.userDetail = null;
      })
      .addCase(GetUserDetailAction.fulfilled, (state, action) => {
        state.userDetailLoading = false;
        state.userDetail = action.payload.response;
      })
      .addCase(GetUserDetailAction.rejected, (state) => {
        state.userDetailLoading = false;
        state.userDetail = null;
      });
  },
});

export default userSlice.reducer;
